import type from './constants';

const initState = {
    // 报价单行信息
    quotationInfo: {},
    // 添加/修改报价单参数
    updateParams: {},
}

export default (state = initState, actions) => {
    switch(actions.type) {
        case type.SAVE_QUOTATION_INFO:
            return {
                ...state,
                quotationInfo: {
                    ...actions.params
                } 
            }
        case type.SAVE_UPDATE_PARAMS:
            return {
                ...state,
                updateParams: {
                    ...actions.params
                }
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/quotation/store/reducer.js